import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import FileManager from './fileManager';
import { useTranslation } from 'react-i18next';

interface GuiFileDialogProps {
    visible: boolean;
    onClose: () => void;
    onSelect: (filePath: string) => Promise<void>;
}

const GuiFileDialog: React.FC<GuiFileDialogProps> = ({ visible, onClose, onSelect }) => {
    const [filePath, setFilePath] = useState<string | undefined>();
    const { t } = useTranslation('common');

    const handleSelect = async () => {
        onSelect(filePath || '');
        return filePath
    };

    const handleClose = () => {
        setFilePath(undefined);
        onClose();
    };

    // const fileFilter = (item: { isDir: boolean, name: string }) => {
    //     const allowedExtensions = ['pdb', 'sdf', 'xyz', 'pqr', 'mol2'];
    //     if (item.isDir) return true;
    //     const fileExtension = item.name.split('.').pop()?.toLowerCase();
    //     return allowedExtensions.includes(fileExtension || '');
    // };

    return (
        <Modal
            title={t('gui_file_dialog.title')}
            open={visible}
            onCancel={handleClose}
            footer={[
                <Button key="cancel" onClick={handleClose}>
                    {t('gui_file_dialog.cancel')}
                </Button>,
                <Button key="save" type="primary" onClick={handleSelect}>
                    {t('gui_file_dialog.select')}
                </Button>,
            ]}
        >
            <div className=' h-60 overflow-hidden'>
                <FileManager hiddenMenu={true} directorySelectHandler={()=>{}} />
            </div>
        </Modal>
    );
};

export default GuiFileDialog;